import React, {ReactNode, useRef, useState} from "react";

export const Accordion = ({summary, children, endAdornment}: {
  summary: ReactNode,
  children: ReactNode,
  endAdornment?: ReactNode,
}) => {
  const [open, setOpen] = useState(false);
  const childElement = useRef<HTMLDivElement>(null);

  const onToggleOpen = (event: React.MouseEvent<HTMLInputElement>) => {
    event.preventDefault(); // デフォルトの制御を無効化
    const details = childElement.current?.parentNode as HTMLDetailsElement;
    const content = details?.querySelector<HTMLDivElement>("summary + div");

    // 閉じる場合のキーフレーム
    const closingAnimation = (content: HTMLElement) => [
      {
        height: `${content.offsetHeight}px`,
        opacity: 1,
      },
      {
        height: 0,
        opacity: 0,
      },
    ];

    // 開く場合のキーフレーム
    const openingAnimation = (content: HTMLElement) => [
      {
        height: 0,
        opacity: 0,
      },
      {
        height: `${content.offsetHeight}px`,
        opacity: 1,
      },
    ];

    // アニメーションタイミング
    const animation = {
      duration: 300,
      easing: "ease-out",
    };

    if (details.open) {
      if (content) {
        setOpen(false);
        content.animate(closingAnimation(content), animation).onfinish = () => {
          details.removeAttribute("open"); // アニメーション完了後に付与する
        };
      }
    } else {
      setOpen(true);
      content?.animate(openingAnimation(content), animation);
      details.setAttribute("open", "true");
    }
  };

  return (
    <details className={'cursor-pointer'}>
      <summary className={'p-1 list-none flex flex-row items-center'} onClick={onToggleOpen}>
        <div className={'w-full'}>
          {summary}
        </div>
        <div className={`transition-all transform ${open ? 'rotate-0' : 'rotate-180'}`}>
          {endAdornment}
        </div>
      </summary>
      <div className={'p-1 overflow-hidden transition-all'} ref={childElement}>
        {children}
      </div>
    </details>
  );
}
